import { gql } from '@apollo/client'

export default gql(`
    mutation deleteTagType($id: ID!, $project: String) {
        deleteTagType(
                input: {
                    id: $id
                }
                project: $project
        ) {
            id
            name
            enabledAssetTypes{
                assetType
            }
        }
    }`
)
